module.exports = __webpack_public_path__ + "static/sp_checkout_3_1-87b78a87ecafacd639f095b015fbf7a7.jpg";